import { Fragment } from 'react'
import { getHighlightSegments, THighlightPosition, THighlightSegment } from './search-highlight.util'

export const HighlightedSegments = ({ segments }: { segments: THighlightSegment[] }) =>
  segments.map((segment, index) =>
    segment.isHighlighted ? (
      <em key={index}>{segment.text}</em>
    ) : (
      <Fragment key={index}>{segment.text}</Fragment>
    ),
  )

type Props = {
  value: string | null | undefined
  searchValue: string
  positions: THighlightPosition[] | undefined
  transformText?: (text: string) => string
}

export const HighlightedText = ({ value, searchValue, positions, transformText }: Props) => (
  <HighlightedSegments
    segments={getHighlightSegments(value, searchValue, positions).map((segment) => ({
      ...segment,
      text: transformText ? transformText(segment.text) : segment.text,
    }))}
  />
)
